import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { Banner, LoadingPage } from '../components/ui';
import { PageHeader } from '../components/PageHeader';

export function CommunityInfoPage() {
  const info = useAsync(async () => (await api.communityPublic()).info, []);

  if (info.loading && !info.data) return <LoadingPage label="Loading community…" />;
  if (!info.data) {
    return <Banner kind="error">Community information is not available.</Banner>;
  }

  const community = info.data;

  return (
    <div>
      <PageHeader
        title="Community Information"
        lede="Official details for your community. Member directories and private contact information are not shown here."
      />

      <div className="card">
        <h3>{community.name}</h3>
        {community.address && <p>{community.address}</p>}
        <dl className="detail-list" style={{ marginTop: 12 }}>
          {community.managementEmail && (
            <>
              <dt className="mut">Management email</dt>
              <dd>{community.managementEmail}</dd>
            </>
          )}
          {community.managementPhone && (
            <>
              <dt className="mut">Management phone</dt>
              <dd>{community.managementPhone}</dd>
            </>
          )}
          {community.boardEmail && (
            <>
              <dt className="mut">Board email</dt>
              <dd>{community.boardEmail}</dd>
            </>
          )}
          {community.boardContactName && (
            <>
              <dt className="mut">Primary board contact</dt>
              <dd>
                {community.boardContactName}
                {community.boardContactPhone ? ` · ${community.boardContactPhone}` : ''}
              </dd>
            </>
          )}
        </dl>
      </div>

      <div className="card">
        <h3>HOA Board Members</h3>
        {community.boardMemberNames.length === 0 ? (
          <p className="mut">No board members are listed yet.</p>
        ) : (
          <ul>
            {community.boardMemberNames.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
